import { BridgeComponent, Message } from '@hotwired/hotwire-native-bridge';

interface AuthorizeMessageData {
  code?: string;
  identityToken?: string;
  error?: string;
}

interface AuthorizationResponseMessage extends Message {
  data: AuthorizeMessageData;
}

export default class AppleAuthController extends BridgeComponent {
  public static component = 'apple-auth';

  private _enable() {
    if ('disabled' in this.element) {
      this.element.disabled = false;
    }
  }

  private _disable() {
    if ('disabled' in this.element) {
      this.element.disabled = true;
    }
  }

  public authorize(e: Event): void {
    e.preventDefault();

    this._disable();

    this.send('authorize', {}, ({ data }: AuthorizationResponseMessage) => {
      this._checkAuthorization(data);
    });
  }

  private _checkAuthorization({
    code,
    identityToken,
    error
  }: AuthorizeMessageData): void {
    this._enable();

    if (error) {
      this._generalError(error);

      return;
    }

    if (!identityToken || !code) {
      this._generalError();

      return;
    }

    const searchParams = new URLSearchParams({
      code,
      id_token: identityToken,
      remember: 'true'
    });

    fetch(`/auth/apple/callback?${searchParams.toString()}`)
      .then(response => {
        if (response.redirected) {
          window.location.reload();
        } else {
          this._generalError();
        }
      })
      .catch(() => {
        this._generalError();
      });
  }

  private _generalError(message?: string) {
    // eslint-disable-next-line no-alert
    alert(
      message ?? 'Could not authenticate using Apple, please try another way.'
    );
  }
}
